import { cn } from '@plato/ui/util/classes';
import type { HeaderProps } from './header.tsx';
import { Header } from './header.tsx';

type PageHeaderProps = HeaderProps;

export function PageHeader({ className, ...props }: PageHeaderProps) {
    return <Header className={cn('mt-3 [&>div:first-child]:min-h-8', className)} {...props} />;
}
